export const messages = {
    HttpStatusCode: {
        200: "OK",
        301: "Moved Permanently",
        302: "Found",
        400: "Bad Request",
        401: "Unauthorized",
        403: "Forbidden",
        404: "Not Found",
        500: "Internal Server Error"
    },
    LoginMessage: {
        Success: "Login successful",
        SessionAboutToTimeOut: "Your session is about to expire",
        SessionTimedOut: "Your session has expired"
    },
    CommonMessage: {
        Success: "Task completed successfully",
        Error: "Something went wrong, please try again",
        Confirmation: "Are you sure you want to proceed with the operation?",
        NoRecords: "No records to show",
        LoadingRecords: "Records are loading...",
        addNewResponseSuccessMsg:"Response added successfully.",
        addnewResponseApiFail:"Unable to save the response. Please try again",
        maxChracterLength:"Maximum 100 characters are allowed",
        TransactionDetailLinkNote: "Click on transaction number link to see complete details. The details screen will open in a new tab.",
        HeaderNote: "Select at least one field or a combination of fields to view the results.",
        HeaderNoteExport: " Hit the export link directly to extract the records for entered search criteria.",
        EntitlementInfoMessage: "User does not have entitlement to perform this action.",
        SearchOiRspNote: "Click on branch id to see complete details. The details screen will open in a new tab.",
        SearchOiRateListMessage: "Select below fields and click search button to view RSP rates in the results.",
        RspAditionalInfoMessage : "Additional info and assigned employees can be viewed from this screen.",
        differentCountrySelected:"Multi selection allowed for single country only"
    },
    FormValidationMessage: {
        CountryNotSelected: "Please select a country",
        DateRangeNotSelected: "Please select from and to dates",
        InvalidDateRange: "To date must be greater than from date",
        DateRangeLimit: "Date range should not be greater than ",
        RSPCodeNotSelected: "Please select a RSP code",
        RSPNameRequired: "RSP name is required",
        ReferenceRSPNameRequired: "Please give valid numeric value in Reference",
        AddNoteRequired: "Please add a note",
        AddCommentRequired: "Please add a comment",
        bbPinsRequired:"Please enter the pins list",
        CityRecipient: "Please enter a valid city recipient",
        OICode: "Please enter a valid OI code",
        additionalCommentMsgLength:"Maximum 256 characters are allowed",
        preDefinedResponseRequiredMsg:"Please select response to agent.",
        addNewResponseLength:"Response field cannot exceed 100 char.",
        addNewResponseRequired:"Response cannot be empty. Please provide new response to add.",
        addNewResponseAlreadyExist:"Response already exists.",
        exportBBMaxLimit: "Please enter Maximum 500 PIN(s)",
        exportBBValidPin: "Please enter valid PIN(s)",
        selectStatus:"Please select a status",
        TransactionNumber: "Please enter a valid Transaction #",
        TFPIN: "Please enter a valid TF PIN",
        PPN: "Please enter a valid PPN",
        ExtReferenceNumber: "Please enter a valid External reference #",
        SenderId: "Please enter a valid Sender id",
        SenderName: "Please enter a valid Sender name",
        RecipientName: "Please enter a valid Recipient name",
        ReferenceId: "Please enter a valid Reference id",
        RSPCode: "Please enter a valid RSP code",
        invalidNoteMsg:"Please enter valid Note. Special character(s) not allowed",
        maxLengthNoteLimit:"Maximum of 420 characters are allowed",
        maxLengthCommentLimit210: "Maximum of 210 characters are allowed",
        maxLengthCommentLimit480: "Maximum of 480 characters are allowed",
        additionalCommentRequired:"Please provide additional comment.",
        maxLengthNoteLimitCPF: "Maximum 256 characters are allowed",
        transactionStatusRequired:"Transaction status required",
        companyRequired:"Please select a company",
        receivingChannelRequired: "Receiving Channel is required",
        senderTypeRequired: "Type is required",
        invalidId : "Please enter valid Id #.",
        invalidRelationship: "Please select Relationship with recipient.",
        invalidNationality: "Please select Nationality.",
        invalidIdExpiryDate: "Please select valid Id expiration date.",
        invalidTypeId: "Please enter valid Type id",
        invalidAddress: "Please enter valid Address.",
        invalidPhone: "Please enter valid Phone number.",
        invalidCpfId : "Please enter valid Cpf id.",
        invalidBirthdate: "Please select valid Birthdate.",
        invalidEmail: "Please enter valid Email.",
        incorrectSenderBirthDate : "Birthday of sender should be 1 day less than today.",
        incorrectBirthDate : "Birthday of recipient should be 1 day less than today.",
        numberIdInvalid: "Recipient Id # required.",
        expiryDateInvalid : "Recipient Id # expiration date required.",
        purposeInvalid : "Please select Purpose.",
        complaintrfiCategoryRequiredMsg : "Please select category",
        complaintCommentMsgLength:"Maximum 256 characters are allowed",
        rfiCommentMsgLength: "Maximum 256 characters are allowed",
        descriptionRequired: "Please provide description",
        invalidTown: "Please select Town.",
        invalidState: "Please select State.",
        invalidCity: "Please select City.",
        invalidExpiryDate :"Id expiration date should be 1 day more than today.",
        invalidNotes: "Please enter valid Notes.",
        phoneNumberRequired: "Please enter Phone number",
        addressRequired: "Please enter address",
        invalidFieldValue: "Please enter valid ",
        maxLengthNoteLimitChangeRequest: "Maximum 100 characters are allowed.",
        currencyNotSelected: "Please select a currency",
        validNumericValue: "Please give valid numeric value.",
        EmployeeNameRequired: "Employee name is required",
        invalidRankName: "Please enter rank name.",
        invalidBackgroundColor : "Please select background color."
    },
    PlaceHolders:{
        SelectOptions: "Select option (s)",
        OriginatingInstitutionId: "Enter Originating institution id",
        OICode: "Enter OI code",
        TransactionNumber: "Enter Transaction #",
        TFPIN: "Enter TF PIN",
        PPN: "Enter PPN",
        ExtReferenceNumber: "Enter External reference #",
        SenderId: "Enter Sender id",
        SenderName: "Enter Sender name",
        RecipientName: "Enter Recipient name",
        ReferenceId: "Enter Reference id",
        RSPCode: "Enter RSP code"
    },
    export:{
        exportSelectRadioOption: "Please select pins option",
        exportNoRecord: "No record found. Please select appropriate search parameter(s) to export the record(s).",
        exportBBLogTitle: "Export notes log",
        exportBBLogDescription: "You can export the notes log using pins from either the data grid or from a list you can retrieve in the RSP code excel sheet.",
        exportBBTextareaPlaceholder: "List a pin on each line to export that corresponding notes log"
    },
    PetitionMessages:{
        ResetDaysSuccess: "Pending since days reset successfully.",
        inactiveResponse:"Please uncheck at least one response to make Inactive.",
        apiFail:"Unable to perform the action. Please try again.",
        recordUpdatedSuccessMsg:"Record updated successfully.",
        responseCreatedMsg:"Response to petition created successfully",
        DaysInTransmitLimit: "Min days in transmit value should be less than equals to 30."
    },
    ProcessUnpaidTransactions:{
        DaysInTransmitLimit: "Min days in transmit value should be less than equals to 30.",
        SelectTransactions: "Please select transaction(s).",
        SelectMaxNumOfTxns: "Please select a Maximum of 50 Transactions.",
        ConfirmResendTxn: "Txn was requested before, do you want to go ahead with the request?... TXN: ",
        ConfirmSelection: "Are you sure you want to Cancel via SendApi?",
        SuccessSendCancelAPI: "The selected transactions have been successfully marked for Cancel via SendAPI.",
        SuccessSendEmail: "Email Successfully Sent.",
        SuccessBulkCancel: "Invoices are canceled successfully.",
        ConfirmCancelSendAPI: "Are you sure you want to cancel these transaction(s) via <strong>“Send API”</strong>?",
        ConfirmCancelSendEmail: "Are you sure you want to email <strong>“Cancel request”</strong> of these transaction(s)?",
        ConfirmBulkCancel: 'Are you sure you want to <strong>“Cancel”</strong> these transaction(s)?',
        ConfirmBABTransaction: "Selected transactions has one or more BAB transactions, so same cancellation reason will be added to all other transactions as that of BAB. Are you sure you want to continue?",
        CancelTransactionTitle: "Cancel transaction(s)",
        CancelPaidTransactionTitle: "Cancel paid invoice",
        InstructionMessage: "Select the transaction(s) from the table to activate the buttons below. A maximum of 50 transactions may be cancelled.",
        SelectReason: "Select the reason for the transaction(s) cancellation along with any necessary details you would like to add.",
        SelectCancellationReason: "Please select cancellation reason.",
        SelectReferenceID: "Please select RSP reference ID.",
        SelectBabCancellationReason: "You should select the following reason:  145 - CONFIRMED CANCELLED-NOT PAID for BAB transaction cancellation. Do you still you want to continue ?",
    },
    TransactionDetails : {
        RetransmitConfirmationMsg : "Are you sure you want to <strong>“Retransmit”</strong> the transaction?",
        ChangeClave: "Are you sure to change clave?",
        TraveRuleDetailsNotFound: "No information has been found.",
        VoidRequest: "Transaction can be cancelled directly, no confirmation required from RSP",
        ChangeCityWarning: "To change city, Transaction should have an <strong>“Hold status”</strong> or <strong>“UNQ BNF Petition”</strong>",
        VoidRequestInvalidTransactionStatus: "Void Request can only be invoked when transaction is in Transmit status.",
        VoidRequestConfirmation: "Are you sure you want to <strong>“Cancel”</strong> this record?",
        changeRequestDescription: "You can change account information from below."
    },
    TransactionStatus : {
        Transmit : "TRANSMIT"
    },
    MakerChecker: {
        HeaderNote: "You can approve, reject and cancel requests from this screen. Only user who has checker access will be able to approve and reject requests of others.",
        ConfirmAction: "Are you sure you want to #Action “<b>#RequesId</b>“ request?" 
    },
    SearchOiRsp: {
        ViewLog: "View log",
        CoverageMessage: "Coverage related logs are captured here.",
        BankMessage: "Banks related logs are captured here.",
        ReceivingChannelMessage: "Receving channel related logs are captured here.",
        SwiftCodeMessage: "Swift code related logs are captured here.",
        ModifyStatus: "Modify RSP status",
        StatusMessage: "Status can be viewed/managed from this screen.",
        History: "HISTORY",
        RedFlag: "Red flag",
        RedFlagInfo: "This screen gives all red flag related information",
        RedFlagLog: "RED FLAG LOG",
        ICANumberLength:"ICA# length must be between 4 to 11 digits",
        InputFilterValidation: "Please select valid search filter."
    },
    LocationAlternateNames: {
        addAlternateNameNote: "Alternate name configuration can be performed from “Add alternate name” button.",
        alternateStateAlreadyExists: "Alternate state name cannot be same as selected state name",
        alternateCityAlreadyExists: "Alternate city name cannot be same as selected city name",
        gridSingleCountrySelection: "Please select record(s) with same country",
        countryNotSelected: "Country is required",
        stateNotSelected: "State is required",
        cityNotSelected: "City is required",
        alternateStateIsRequired: "State alternate name is required",
        alternateCityIsRequired: "City alternate name is required"
    },
    RspCsSetup: {
        HeaderNote: "Select RSP from a below drop-down to open relevant CS setup info.",
        SearchIsMandatory: "Please search for RSP CS setup.",
        SelectCancellationRequestVia: "Please select cancellation request via.",
        EmailMaxLengthValid: "Maximum 600 characters are allowed.",
        ReceivingChannelLogNote: "Select below fields and click search button to view receiving channel log in the results.",
        SetupLogNote: "Select below fields and click search button to view setup log in the results.",
        EmailToMsg : 'Please enter to email.',
        EmailReplyMsg : 'Please enter reply to email.'
    },
    OiRanks:{
        OiRanksTitle: 'OI ranks',
        CreateRank: 'Create new rank',			
        EditRank: 'Edit rank',					
        OiRanksSubText: 'OI rankings can be configured from this screen. A new rank can be created via the "Create new" button and modified one at a time via the edit or delete links. ',
        OiRanksSubTextForCreate: 'OI rank can be configured from this screen.',
        OiRanksSubTextForEdit: 'OI rank can be modified from this screen.',
        Preview:'PREVIEW',
        PreviewText: 'Displaying rank name over background color',
        DefaultColorText:'Text color is defaulted to black',	
        DeleteRankText: 'Are you sure you want to delete this rank?'
    },
    PaidStatusInquiry: {
        minHoursInTransmitRequired: "Minimum hours in transmit should be greater than or equal to 1.",
        SelectTransactions: "Please select transaction(s).",
        SelectMaxNumOfTxns: "Please select a Maximum of 50 Transactions.",
        ConfirmResendTxn: "Txn was requested before, do you want to go ahead with the request?... TXN: ",
        ConfirmSelection: "Are you sure you want to Cancel via SendApi?",
        SuccessSendCancelAPI: "The selected transactions have been successfully marked for Cancel via SendAPI.",
        SuccessSendEmail: "Email Successfully Sent.",
        SuccessBulkCancel: "Invoices are canceled successfully.",
        ConfirmCancelSendAPI: "Are you sure you want to Cancel via SendApi?",
        ConfirmCancelSendEmail: "Are you sure you want to Email Cancel request?",
        ConfirmBulkCancel: "Are you sure to cancel these transactions?",
        ConfirmBABTransaction: "Selected transactions has one or more BAB transactions, so same cancellation reason will be added to all other transactions as that of BAB. Are you sure you want to continue?",
        CancelTransactionTitle: "Cancel transaction(s)",
        SelectReason: "Select the reason for the transaction(s) cancellation along with any necessary details you would like to add.",
        gridMessage: "Click on transaction number link to see complete details. The details screen will open in a new tab.",
        confirmEmail : "Are you sure you want to email paid status request?"
	}
}